// LAAP Tracker Service - Service layer for LAAP tracker API operations

import axiosInstance from "../instance/axiosInstance";
import { LAAP_ENDPOINTS } from "../endpoints/laap.endpoints";
import { handleApiError } from "../utils/errorHandler";

export const LAAPService = {
  // Get LAAP tracker records for a user/role
  getRecords: async (userId, roleId) => {
    try {
      const response = await axiosInstance.get(
        LAAP_ENDPOINTS.GET_RECORDS(userId, roleId),
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Save a new LAAP tracker record
  saveRecord: async (payload) => {
    try {
      const response = await axiosInstance.post(
        LAAP_ENDPOINTS.SAVE_RECORD,
        payload,
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Update an existing LAAP tracker record
  updateRecord: async (payload) => {
    try {
      const response = await axiosInstance.patch(
        LAAP_ENDPOINTS.UPDATE_RECORD,
        payload,
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Delete a LAAP tracker record
  deleteRecord: async (recordId) => {
    try {
      const response = await axiosInstance.delete(
        LAAP_ENDPOINTS.DELETE_RECORD(recordId),
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },
};

export default LAAPService;
